import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { clsx } from 'clsx';
import { adminApi } from '../lib/api';
import { clearAdminSession, getAdminSession } from '../lib/auth';

interface MenuItem {
  to: string;
  label: string;
  icon: string;
}

const MENU: MenuItem[] = [
  { to: '/', label: '대시보드', icon: '◆' },
  { to: '/users', label: '회원', icon: '◇' },
  { to: '/applications', label: '이용 신청', icon: '✎' },
  { to: '/cost', label: '비용', icon: '○' },
];

export function AdminLayout() {
  const nav = useNavigate();
  const session = getAdminSession();

  async function logout() {
    try {
      await adminApi.logout();
    } catch {
      // 토큰 만료 등 — 로그아웃은 어쨌든 진행
    } finally {
      clearAdminSession();
      nav('/login', { replace: true });
    }
  }

  return (
    <div className="min-h-screen flex bg-bg text-text-primary">
      <aside className="w-56 shrink-0 border-r border-border bg-surface flex flex-col">
        <div className="px-5 py-5 border-b border-border">
          <div className="text-[11px] uppercase tracking-widest text-text-muted">Butler</div>
          <div className="text-sm font-semibold text-text-primary mt-1">백오피스</div>
        </div>
        <nav className="flex-1 py-3 px-2 space-y-0.5">
          {MENU.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                clsx(
                  'flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors',
                  isActive
                    ? 'bg-accent-tint text-accent border border-accent/30'
                    : 'text-text-secondary hover:text-text-primary hover:bg-surface-elev',
                )
              }
            >
              <span className="text-text-muted text-xs">{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-border p-3 space-y-2">
          <div className="text-[11px] text-text-muted px-2 truncate" title={session?.email ?? ''}>
            {session?.email ?? 'unknown'}
          </div>
          <button onClick={logout} className="btn-ghost w-full justify-start">
            로그아웃
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        <div className="max-w-6xl mx-auto px-8 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
